import { ReactElement } from "react"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { HorizontalSecondaryTab } from "../../../ui/organisms/horizontalSecondaryTab"
import { Tab } from "../../../ui/organisms/tab"
import { setSelectedTabAirport } from "../slice"
import { Arrivals } from "./arrivals"
import { Departures } from "./departures"
import { DeparturesIcon } from "../../../ui/icons/departuresIcon"
import { colors } from "../../../ui/color"
import { ArrivalIcon } from "../../../ui/icons/arrivalsIcon"

export function AirportTraffic() {
    const dispatch = useAppDispatch()

    const reportState = useAppSelector((state) => state.report)

    const viewAirportMap = new Map<number, ReactElement>([
        [0, <Departures />],
        [1, <Arrivals />],
    ])

    return (
        <>
            <HorizontalSecondaryTab>
                <Tab
                    label={"Departures"}
                    selectedSecondary={reportState.selectedTabAirport === 0}
                    onClick={() => dispatch(setSelectedTabAirport(0))}
                    type="secondary"
                    icon={<DeparturesIcon size={20} color={colors.neutral[700]} />}
                />
                <Tab
                    label={"Arrivals"}
                    selectedSecondary={reportState.selectedTabAirport === 1}
                    onClick={() => dispatch(setSelectedTabAirport(1))}
                    type="secondary"
                    icon={<ArrivalIcon size={20} color={colors.neutral[700]} />}
                />
            </HorizontalSecondaryTab>
            {viewAirportMap.get(reportState.selectedTabAirport)}
        </>
    )
}